export default __webpack_public_path__ + "static/media/requestFlow-bg.29afd37f.jpg";